module.exports = __webpack_public_path__ + "images/accents/ao-download@2x-dcf5db281a2cb1cb9d6c94487268aac9.webp";